// extracted by mini-css-extract-plugin
module.exports = {"mapWrapper":"Map_mapWrapper__zQ_hw","mapTitle":"Map_mapTitle__8roFi"};